// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  //apiUrl: 'http://localhost:8082',
  apiUrl: 'http://happy-connects.ap-south-1.elasticbeanstalk.com',

  userPhotoHost: 'https://users-photo-store-s3-dev-new.s3.ap-south-1.amazonaws.com/',
  activityPhotoHost : 'https://store-activity-contents-dev-new.s3.ap-south-1.amazonaws.com/',
  production: false,
  chatServiceTopicName : '/happy-connect-chatter'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in prodpuction mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
